import type { SVGProps } from 'react'

export const IndeterminateCheckBoxFilledIcon = ({
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M320-450h320q12.77 0 21.38-8.62Q670-467.23 670-480t-8.62-21.38Q652.77-510 640-510H320q-12.77 0-21.38 8.62Q290-492.77 290-480t8.62 21.38Q307.23-450 320-450ZM212.31-140Q182-140 161-161q-21-21-21-51.31v-535.38Q140-778 161-799q21-21 51.31-21h535.38Q778-820 799-799q21 21 21 51.31v535.38Q820-182 799-161q-21 21-51.31 21H212.31Z" />
    </svg>
  )
}
